<p-breadcrumb [model]="crumbs"></p-breadcrumb><br>
<p-messages [value]="messages"></p-messages>

<!--- /// List Group /// --->
<div *ngIf="action.listGroup">
   <app-list-user-group 
        (doAddGroupEvent)="showHideAddUserGroup($event)" 
        (doEditGroupEvent)="showHideEditUserGroup($event)"
        (selectedUserGroup)="setSelectedGroup($event)" 
        (existingGroupNames)="setExistingGroupNames($event)"
        [incomingMessage]="message">
    </app-list-user-group>
</div>

<!--- /// Add Group /// --->
<div *ngIf="action.addGroup">
    <app-add-user-group 
        (cancelAddEvent)="showHideAddUserGroup($event)" 
        (setBreadCrumbs)="setBreadCrumbs($event)"
        (setMessage)="setMessage($event)"
        [existingGroupNames]="existingGroupNames">
    </app-add-user-group>
</div>

<!--- /// Edit Group /// --->
<div *ngIf="action.editGroup">
    <app-edit-user-group 
        (cancelEditEvent)="showHideEditUserGroup($event)" 
        (setBreadCrumbs)="setBreadCrumbs($event)" 
        (setMessage)="setMessage($event)"
        [currentUserGroup]="selectedUserGroup"
        [existingGroupNames]="existingGroupNames">
    </app-edit-user-group>
</div>